<header *ngIf="user" class="memic-header">
  <nav class="navbar navbar-expand-lg p-0 nav-top">
    <!-- // Brand Nav -->
    <!-- Top Nav -->
    <div class="collapse navbar-collapse nav-wrapper d-flex flex-wrap align-items-center justify-content-center justify-content-md-between">
      <div class="d-flex memic-header__logo">
        <img src="../../assets/images/memic-logo-white.png" />
      </div>      
      <div class="d-flex p-2 p-lg-0 text-end">
        <!-- Welcome -->
        <div class="nav-persona">
          <div class="nav-row">
            <div class="nav-item nav-notification">
              <a class="nav-link" href="javascript:void(null)" (click)="routeToFavorites()">
                <i class="fa fa-star"></i>
                <span class="badge" *ngIf="getFavoritesCount() && getFavoritesCount() > 0">{{getFavoritesCount()}}</span>
              </a>
            </div>

            <div class="dropdown" ngbDropdown>
              <button class="nav-item nav-link dropdown-toggle" id="persona" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                Welcome, {{user.firstName}}
              </button>
              <div class="dropdown-menu dropdown-menu-right" style="width: 320px" aria-labelledby="persona" ngbDropdownMenu>
                <div class="px-4 py-3">
                  <!-- 2 column grid layout for inline styling -->
                  <div class="row mb-4">
                    <div class="col d-flex justify-content-center">
                      <div class="dropdown-item">{{user.firstName}} {{user.lastName}}</div>
                      <div class="dropdown-item">{{user.policyNumber}}</div>
                    </div>

                    <div class="col">
                      <div class="dropdown-item">{{user.businessSegment}}</div>
                      <div class="dropdown-item">{{user.naicsInformation.description}}</div>
                    </div>
                  </div>

                </div>
                <div class="dropdown-divider"></div>
                <button class="dropdown-item" href="#" (click)="logout()" ngbDropdownItem><i class="fa fa-power-off"></i> Logout</button>
              </div>
            </div>
          </div>
        </div>
        <!-- Industry Selector -->
        <div class="nav-industry">
          <div class="nav-row">
            <div class="dropdown" ngbDropdown>
              <button class="nav-item nav-link dropdown-toggle" id="industries" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle>
                Selected Industry ({{selectedIndustry}})
              </button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="industries" ngbDropdownMenu>
                <button class="dropdown-item" href="#" *ngFor="let industry of primaryIndustries" (click)="updateIndustry(industry.name)" ngbDropdownItem>{{industry.name}}</button>
              </div>
            </div>
          </div>
        </div>
        <!-- // Industry Selector -->
        <!-- Search -->
        <div class="p-2">
          <div class="search">
            <i class="fa fa-search"></i>
            <input [(ngModel)]="searchString" (keyup.enter)="filterResources()" name="searchString" type="text" class="form-control" placeholder="Search">
            <span (click)="filterResources()" class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i></span>
          </div>
        </div>
        <!--// Search -->
      </div>            
    </div>
  </nav>
  <!-- // Top Nav -->
  <!-- Main Menu -->
  <div class="menu-component">
    <div class="w-100 nav-wrapper">
      <nav class="navbar navbar-expand-lg collapse-nav">
        <!-- Mobile Menu -->
        <button class="navbar-toggle" type="button" data-bs-toggle="collapse" data-bs-target="#memic-navbar"
                aria-controls="memic-navbar" aria-expanded="false" aria-label="Toggle navigation">
          <span>MENU</span>
        </button>
        <!-- // Mobile Menu -->
        <!-- Brand Nav -->
        <div class="d-flex flex-column flex-lg-row">
          <div class="d-flex">
            <a class="navbar-brand memic-header__safety-director-logo ms-4 ms-lg-0" [routerLink]="['/']">
              <img src="../../assets/images/safety-director-logo.png" />
            </a>
          </div>
        </div>
        <!-- Main Nav -->
        <div id="memic-navbar" class="collapse navbar-collapse justify-content-center main-nav" aria-labelledby="memic-navbar">
          <ul class="navbar-nav">
            <li class="nav-item" ngbDropdown>
              <a class="nav-link link-padding dropdown-toggle" href="javascript:void(0)" id="industryResourcePages" ngbDropdownToggle>
                Industry Resources
              </a>
              <div ngbDropdownMenu aria-labelledby="industryResourcePages">
                <a *ngFor="let resourcePage of resourcePages" class="dropdown-item" [routerLink]="['/industry-resources/', resourcePage.industry]" ngbDropdownItem>{{resourcePage.title}}</a>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link link-padding" [routerLink]="['/e-ergo']">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 nav-text">E-Ergo</div>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link link-padding" [routerLink]="['/memic-minutes']">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 nav-text">MEMIC Minutes</div>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link link-padding" [routerLink]="['/dementia-series']">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 nav-text">Dementia Care Series</div>
                </div>
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link link-padding" [routerLink]="['/webinars-on-demand']">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1 nav-text">Webinars on Demand</div>
                </div>
              </a>
            </li>
          </ul>
        </div>
        <!-- // Main Nav -->
      </nav>
    </div>
  </div>
  <!-- // Main Menu -->
</header>
